import { render, staticRenderFns } from "./MemberSelector.vue?vue&type=template&id=671321fc"
import script from "./MemberSelector.vue?vue&type=script&lang=js"
export * from "./MemberSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports